import { useEffect, useState } from 'react'
import { useRef } from 'react'
import './index.scss'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import emailjs from '@emailjs/browser'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const refForm = useRef()

  const [formValues, setFormValues] = useState({
    from_name: '',
    email: '',
    subject: '',
    message: '',
  })

  const [statusMessage, setStatusMessage] = useState('')
  const [statusType, setStatusType] = useState('')
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setLetterClass('text-animate-hover'), 2500)
    return () => clearTimeout(timer)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_hjsut25',
        'template_5q83l5c',
        refForm.current,
        'SgqU2jwwHCro5smRT'
      )
      .then(
        () => {
          setFormValues({ from_name: '', email: '', subject: '', message: '' })
          setStatusMessage('Message successfully sent!')
          setStatusType('success')
          setIsVisible(false)
          
          // Trigger fade-in
          setTimeout(() => {
            setIsVisible(true)
          }, 10)
          
          // Start fade out after 4 seconds
          setTimeout(() => {
            setIsVisible(false)
          }, 4000)
          
          // Remove from DOM after fade completes
          setTimeout(() => {
            setStatusMessage('')
          }, 4500)
        },
        (error) => {
          console.error('EmailJS Error:', error)
          setStatusMessage('Failed to send the message, please try again.')
          setStatusType('error')
          setIsVisible(false)
          
          // Trigger fade-in
          setTimeout(() => {
            setIsVisible(true)
          }, 10)
          
          // Start fade out after 4 seconds
          setTimeout(() => {
            setIsVisible(false)
          }, 4000)
          
          // Remove from DOM after fade completes
          setTimeout(() => {
            setStatusMessage('')
          }, 4500)
        }
      )
  }

  return (
    <>
      <div className='container contact-page'>
        <div className='text-zone'>
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C','o','n','t','a','c','t',' ','m','e']}
              idx={15}
              showCursor
            />
          </h1>
          <p>
            I am interested in Software Engineering opportunities —
            especially ambitious and exciting projects. However if you
            have other projects in mind please do not hesitate to connect with me
            using the form below!
          </p>

          <div className='contact-form'>
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className='half'>
                  <input
                    type='text'
                    name='from_name'
                    placeholder='Name'
                    required
                    value={formValues.from_name}
                    onChange={(e) =>
                      setFormValues({ ...formValues, from_name: e.target.value })
                    }
                  />
                </li>

                <li className='half'>
                  <input
                    type='email'
                    name='email'
                    placeholder='Email'
                    required
                    value={formValues.email}
                    onChange={(e) =>
                      setFormValues({ ...formValues, email: e.target.value })
                    }
                  />
                </li>

                <li>
                  <input
                    type='text'
                    name='subject'
                    placeholder='Subject'
                    required
                    value={formValues.subject}
                    onChange={(e) =>
                      setFormValues({ ...formValues, subject: e.target.value })
                    }
                  />
                </li>

                <li>
                  <textarea
                    name='message'
                    placeholder='Message'
                    required
                    value={formValues.message}
                    onChange={(e) =>
                      setFormValues({ ...formValues, message: e.target.value })
                    }
                  />
                </li>

                <li>
                  <input type='submit' className='flat-button' value='SEND' />
                </li>
              </ul>
            </form>

            {/* Inline status message */}
            {statusMessage && (
              <p className={`status-message ${statusType} ${isVisible ? 'visible' : 'hidden'}`}>
                {statusMessage}
              </p>
            )}
          </div>
        </div>

        <div className='info-map'>
          Ryan Saini
          <br />
          United States
          <br />
          San Francisco Bay Area, CA.
          <br />
          <span>RyanSaini@icloud.com</span>
        </div>

        <div className='map-wrap'>
          <MapContainer center={[37.7749, -122.4194]} zoom={11}>
            <TileLayer url=" https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />
            <Marker position={[37.7749, -122.4194]}>
              <Popup>I'm based in the San Francisco Bay Area.</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      

      

      <Loader type='pacman' />
    </>
  )
}

export default Contact